import React from 'react';
import { FundTag } from './FundTag';
import styles from './FundTags.module.css';

export const NewFundTag = (props) => {
  return <FundTag text="New" className={styles.newFundTag} {...props} />;
};
